import React from 'react'

const ProvinceLabel = ({ textSize, smallSize }) => {
  const province = process.env.REACT_APP_PROVINCE || ''
  const fontSize = province.length > 10 ? (smallSize ?? textSize) : textSize

  return (
    <p className={`font-bold text-grey font-inter ${fontSize}`}>
      {province}
    </p>
  )
}

export default ProvinceLabel
